import React, { useContext } from 'react';
import InputBase from '../InputBase';
import PersonIcon from '@material-ui/icons/Person';
import Select from '../../engine/SelectEngine';
import styled from 'styled-components/macro';
import FieldTitle from '../FieldTitle';
import { FormContext } from '../FormContext';
import formatDate from '../../../utils/formatDate';
import InputAdornment from '@material-ui/core/InputAdornment';
import LinkFieldEngine from '../engine/LinkFieldEngine';

const OTClassicFormFieldSelect = styled(Select)`
  && {
    border-color: rgba(0, 0, 0, 0.23);
    border-style: solid;
    border-width: 1px;
    width: 100%;
    max-width: initial;
    padding: 0 0.8em;
    margin: 0;
    font-size: 14px;
  }

  input {
    padding: 0.5em 0.8em;
  }

  &:hover {
    border-color: #000;
  }
`;

const SubFieldsContainer = styled.div`
  margin: 0 0 0 2rem;
`;

const LineItem = styled.div`
  border-left: 1px solid #c4c4c4 !important;
  left: -1.5rem !important;
  position: absolute;
  width: 1rem;
  top: ${props => (props.first ? '0.5rem' : '-1rem')};
  bottom: 14px;
  border-bottom: 1px solid #c4c4c4 !important;
`;

const LookupFieldView = ({
  subFields,
  submissionId,
  userId,
  customStatusesById,
  ...props
}) => {
  const { variant } = useContext(FormContext);

  return (
    <div submission-id={submissionId} user-id={userId}>
      <OTClassicFormFieldSelect
        searchable
        asyncOptions={searchValue =>
          props.asyncOptions(searchValue, props.value)
        }
        placeholder={
          props.value ? props.value : 'forms.field.dropdown.placeholder'
        }
        disabled={props.readOnly}
        value={props.value}
        onChange={props.onChange}
        variant={variant}
        forceNonMobileVersion
        isUserLookup={props.lookupType === 'user'}
        startAdornment={
          props.lookupType === 'user' ? (
            <InputAdornment position="start">
              <PersonIcon style={{ color: '#8c93a7' }} />
            </InputAdornment>
          ) : null
        }
      />
      <SubFieldsContainer>
        {subFields.map((one, k) => {
          let displayValue, matchingStatus;
          displayValue = props.subFieldValues[k] || '';
          if (one.uiType === 'date' && props.subFieldValues[k]) {
            displayValue = formatDate(props.subFieldValues[k], null, 'L');
          } else if (one.uiType === 'status' && props.subFieldValues[k]) {
            displayValue = props.subFieldValues[k].replace(/\|/g, '');
            matchingStatus = customStatusesById[displayValue];
            if (matchingStatus) {
              displayValue = matchingStatus.label;
            }
          } else if (one.uiType === 'link' && props.subFieldValues[k]) {
            return (
              <div
                key={k}
                field-id={one.localFormFieldId}
                value={props.subFieldValues[k]}
                style={{ position: 'relative' }}
                onClick={props.onClickSubField}
              >
                <LineItem first={k === 0} />
                <FieldTitle title={one.title} isReadOnly={true} />
                <LinkFieldEngine
                  internalId={one.localFormFieldId}
                  value={displayValue}
                  readOnly
                  setValue={() => {}}
                />
              </div>
            );
          }
          return (
            <div
              key={k}
              field-id={one.localFormFieldId}
              value={props.subFieldValues[k]}
              style={{ position: 'relative' }}
              onClick={props.onClickSubField}
            >
              <LineItem first={k === 0} />
              <FieldTitle title={one.title} isReadOnly={true} />
              <InputBase
                disabled={props.readOnly}
                variant="outlined"
                value={displayValue}
                inputProps={{ readOnly: true }}
              />
            </div>
          );
        })}
      </SubFieldsContainer>
    </div>
  );
};

export default LookupFieldView;
